import http from '@/http'

const PATH = '/tools/bundles'

function getPath (bundleId) {
    return `${PATH}/${bundleId}/usage-history`
}

export default {
    /**
     * @param {{bundleId: number, params: {}}} params
     * @returns {Promise<void>}
     */
    async listUsageHistory ({bundleId, params}) {
        try {
            try {
                const response = await http.get(getPath(bundleId), {params})
                return response.data
            } catch (e) {
                return Promise.reject(e)
            }
        } catch (e) {
            return Promise.reject(e)
        }
    }
}